
    JSONEditor.defaults.theme = 'foundation5';
    JSONEditor.defaults.iconlib = 'fontawesome4';
    JSONEditor.defaults.options.disable_array_reorder = 'true';
    JSONEditor.defaults.options.disable_edit_json = 'true';
    JSONEditor.defaults.options.disable_properties = 'true';
    JSONEditor.defaults.options.show_errors = 'always';
   


// WEBPACK FOOTER //
// src/assets/js/jsonPathLoader.js